'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _regeneratorRuntime = require('@babel/runtime-corejs3/regenerator');
var _Promise = require('@babel/runtime-corejs3/core-js-stable/promise');
var _asyncToGenerator = require('@babel/runtime-corejs3/helpers/asyncToGenerator');
var _bindInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/bind');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var globalThis = require('@tanker/global-this');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _Promise__default = /*#__PURE__*/_interopDefaultLegacy(_Promise);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _bindInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_bindInstanceProperty);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var globalThis__default = /*#__PURE__*/_interopDefaultLegacy(globalThis);

var FileReader = /*#__PURE__*/function () {
  function FileReader(source) {
    var _context, _context2, _context3;

    _classCallCheck__default['default'](this, FileReader);

    _defineProperty__default['default'](this, "_source", void 0);

    _defineProperty__default['default'](this, "_reader", void 0);

    _defineProperty__default['default'](this, "_readPositions", {
      start: 0,
      end: 0
    });

    _defineProperty__default['default'](this, "_currentRead", void 0);

    this._source = source;
    this._reader = new globalThis__default['default'].FileReader();

    this._reader.addEventListener('load', _bindInstanceProperty__default['default'](_context = this._onLoad).call(_context, this));

    this._reader.addEventListener('error', _bindInstanceProperty__default['default'](_context2 = this._onError).call(_context2, this));

    this._reader.addEventListener('abort', _bindInstanceProperty__default['default'](_context3 = this._onError).call(_context3, this));
  }

  _createClass__default['default'](FileReader, [{
    key: "_onLoad",
    value: function _onLoad() {
      if (!this._currentRead) throw new Error('Assertion error: a result was received but no read operation was in progress');
      var resolve = this._currentRead.resolve;
      this._currentRead = null;
      resolve(this._reader.result);
    }
  }, {
    key: "_onError",
    value: function _onError() {
      // Ignore errors if no current read (happens in Safari because calling abort() will trigger
      // both 'abort' and 'error' events, whereas no 'error' event is fired in other browsers)
      if (!this._currentRead) {
        return;
      }

      var reject = this._currentRead.reject;
      this._currentRead = null;
      reject(this._reader.error);
    }
  }, {
    key: "_assertNoReadInProgress",
    value: function _assertNoReadInProgress() {
      if (this._currentRead) throw new Error('Assertion error: a read operation is already in progress');
    }
  }, {
    key: "abort",
    value: function abort() {
      return this._reader.abort();
    }
  }, {
    key: "readAsDataURL",
    value: function () {
      var _readAsDataURL = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._assertNoReadInProgress();

                return _context4.abrupt("return", new _Promise__default['default'](function (resolve, reject) {
                  _this._currentRead = {
                    resolve: resolve,
                    reject: reject
                  };

                  _this._reader.readAsDataURL(_this._source);
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee, this);
      }));

      function readAsDataURL() {
        return _readAsDataURL.apply(this, arguments);
      }

      return readAsDataURL;
    }()
  }, {
    key: "readAsText",
    value: function () {
      var _readAsText = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2(encoding) {
        var _this2 = this;

        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._assertNoReadInProgress();

                return _context5.abrupt("return", new _Promise__default['default'](function (resolve, reject) {
                  _this2._currentRead = {
                    resolve: resolve,
                    reject: reject
                  };

                  _this2._reader.readAsText(_this2._source, encoding);
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee2, this);
      }));

      function readAsText(_x) {
        return _readAsText.apply(this, arguments);
      }

      return readAsText;
    }()
  }, {
    key: "readAsArrayBuffer",
    value: function () {
      var _readAsArrayBuffer = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(byteSize) {
        var _this3 = this;

        var start, end, blobSlice;
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._assertNoReadInProgress();

                start = this._readPositions.end;
                end = byteSize ? Math.min(start + byteSize, this._source.size) : this._source.size;
                this._readPositions = {
                  start: start,
                  end: end
                }; // $FlowIgnore cross-browser compat

                blobSlice = _sliceInstanceProperty__default['default'](Blob.prototype) || Blob.prototype.mozSlice || Blob.prototype.webkitSlice;
                return _context6.abrupt("return", new _Promise__default['default'](function (resolve, reject) {
                  _this3._currentRead = {
                    resolve: resolve,
                    reject: reject
                  };

                  _this3._reader.readAsArrayBuffer(blobSlice.call(_this3._source, start, end));
                }));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3, this);
      }));

      function readAsArrayBuffer(_x2) {
        return _readAsArrayBuffer.apply(this, arguments);
      }

      return readAsArrayBuffer;
    }()
  }]);

  return FileReader;
}();

exports.FileReader = FileReader;
exports.default = FileReader;
